import { render, staticRenderFns } from "./oneFileFolder.vue?vue&type=template&id=b15fd69a&scoped=true"
import script from "./oneFileFolder.vue?vue&type=script&lang=js"
export * from "./oneFileFolder.vue?vue&type=script&lang=js"
import style0 from "./oneFileFolder.vue?vue&type=style&index=0&id=b15fd69a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15fd69a",
  null
  
)

export default component.exports